import { render, staticRenderFns } from "./ClipboardQuickInsertPopover.vue?vue&type=template&id=b4da72dc&scoped=true"
import script from "./ClipboardQuickInsertPopover.vue?vue&type=script&lang=js"
export * from "./ClipboardQuickInsertPopover.vue?vue&type=script&lang=js"
import style0 from "./ClipboardQuickInsertPopover.vue?vue&type=style&index=0&id=b4da72dc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4da72dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4da72dc')) {
      api.createRecord('b4da72dc', component.options)
    } else {
      api.reload('b4da72dc', component.options)
    }
    module.hot.accept("./ClipboardQuickInsertPopover.vue?vue&type=template&id=b4da72dc&scoped=true", function () {
      api.rerender('b4da72dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/clipboard/ClipboardQuickInsertPopover.vue"
export default component.exports